import React, { useCallback } from 'react'
import styled from '@emotion/styled'

import { Icon } from 'util/ui'

export default styled(Actions)`
  border-top: 1px solid ${props => props.theme.color.monochrome.medium};
  margin: 0 -${props => props.theme.spacing['10']};
  padding: ${props => props.theme.spacing['5']}
    ${props => props.theme.spacing['10']} 0;
  .actions {
    margin-top: ${props => props.theme.spacing['7']};
  }
  .action {
    margin-right: ${props => props.theme.spacing['10']};
    color: ${props => props.theme.color.primary.brand};
    cursor: pointer;
    display: inline-block;
    &:last-child {
      margin-right: 0;
    }
  }
`

function Actions({ actions, className, id }) {
  if (!actions || actions.length === 0) return null
  return (
    <div className={className}>
      <strong>Actions</strong>
      <div className="actions">
        {actions.map((actionItem, index) => {
          if (!actionItem) return null
          const { action, icon, text } = actionItem
          return (
            <span
              className="action"
              // eslint-disable-next-line react/no-array-index-key
              key={`${text}-${index}`}
              // eslint-disable-next-line react-hooks/rules-of-hooks
              onClick={useCallback(() => action(id), [action])}
            >
              {icon && <Icon name={icon} />} {text}
            </span>
          )
        })}
      </div>
    </div>
  )
}
